var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgStatusBug = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.357 9.64282C15.6587 10.9446 15.6587 13.0551 14.357 14.3569C13.0552 15.6586 10.9447 15.6586 9.64294 14.3569C8.34119 13.0551 8.34119 10.9446 9.64294 9.64282C10.9447 8.34107 13.0552 8.34107 14.357 9.64282",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3033 6.6967C20.2322 9.62563 20.2322 14.3744 17.3033 17.3033C14.3743 20.2322 9.62562 20.2322 6.6967 17.3033C3.76777 14.3743 3.76777 9.62562 6.6967 6.6967C9.62563 3.76777 14.3744 3.76777 17.3033 6.6967",
    stroke: "#FF0000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgStatusBug);
export default ForwardRef;